import { CZQWait } from 'lib/util/utils'

export default {
	// {{{ data
	data () {
		return {
			data: [],
			show: true,
			popup: true,
			height: 0,
			reject: null,
			resolve: null,
			hasMore: true,
			loading: false,
			selected: null,
			defaults: null,
			maxHeight: 0,
			canAdjust: true,
			listHeight: 0,
			scrollerHeight: 0,
			limit: {
				p: 1,
				s: 10
			},
			options: {
				filter: {},
				paging: false,
				searchable: false,
				placeholder: '请输入'
			},
			keyword: '',
			localKeyword: '',
			remoteKeyword: ''
		}
	},
	// }}}
	// {{{ props
	props: {
		multiple: {
			type: Number,
			default: 1
		}
	},
	// }}}
		// {{{ watch
		watch: {
			keyword (keyword) {
				if (this.options.paging) {
					// TODO
				} else {
					this.localKeyword = keyword
				}
			}
		},
		// }}}
		// {{{ created
		created () {
			this.defaults = Object.assign({}, this.options)
			this.maxHeight = document.body.clientHeight * .45; // 内置键盘会占用一半的空间
		},
		// }}}
	// {{{ methods
	methods: {
		// {{{ open
		open (options) {
			this.options = Object.assign(this.defaults, options)
			this.selected = null
			this.show = true
			this.popup = true
			this.canAdjust = true
			this.reloadData()
			return new Promise((resolve, reject) => {
				this.reject = reject
				this.resolve = resolve
			})
		},
		// }}}
		// {{{ search
		search () {
			this.remoteKeyword = this.keyword
			this.resetData()
			this.reloadData()
		},
		// }}}
		// {{{ select
		select (item) {
			this.selected = item
			if (this.multiple === 1) {
				this.hideSelect().then(() => this.resolve(this.selected))
			}
		},
		// }}}
		// {{{ onScroll
		onScroll (e) {
			if (!this.options.paging) {
				return
			}
			var el = e.target
			if (this.hasMore && !this.loading && el.scrollTop >= el.scrollHeight - el.offsetHeight) {
				++this.limit.p
				this.reloadData()
			}
		},
		// }}}
		// {{{ resetData
		resetData () {
			this.data = []
			this.limit.p = 1
			this.hasMore = true
		},
		// }}}
		// {{{ reloadData
		reloadData () {
			var options = this.options
			var filter = Object.assign({
				k: this.remoteKeyword
			}, this.limit, options.filter)
			if (!options.paging) {
				delete filter.s
			} else {
				this.loading = true
			}
			options.dataSource(filter).then(data => {
				if (data.length < this.limit.s) {
					this.hasMore = false
				}
				this.data = this.data.concat(data)
				this.$nextTick(this.adjustHeight)
				this.loading = false
			}).catch(() => {
				this.loading = false
			})
		},
		// }}}
		// {{{ hideSelect
		hideSelect () {
			this.popup = false
			this.keyword = ''
			this.localKeyword = ''
			this.remoteKeyword = ''
			return CZQWait(300).then(() => {
				this.show = false
				this.height = 0
				this.resetData()
			})
		},
		// }}}
		// {{{ isSelected
		isSelected (item) {
			return this.selected === item
		},
		// }}}
		// {{{ adjustHeight
		adjustHeight () {
			if (!this.canAdjust) {
				return
			}
			this.canAdjust = false
			CZQWait().then(() => {
				var height = this.$refs.list.offsetHeight
				if (height > this.maxHeight) {
					height = this.maxHeight
				}
				this.scrollerHeight = height
				var search = this.$refs.search
				if (search) {
					height += search.offsetHeight
				}
				this.height = height
			})
		}
		// }}}
	},
	// }}}
	// {{{ computed
	computed: {
		// {{{ filterData
		filterData () {
			return this.data.filter(item => {
				return item.name.indexOf(this.localKeyword) > -1
			})
		}
		// }}}
	}
	// }}}
}



// WEBPACK FOOTER //
// ./src/lib/czqui/popup-list/CZQPopupList.js